import React from 'react';

import Modal from '../../../common/Modal';
import * as shapes from '../../shapes';

const AddAnotherBarber = ({ barbers, addBarber, on, off, isOn, canAddAnotherBarber }) => (
  <div
    className="u-text-center u-ph extralarge-and-up-ph++ u-pv"
  >
    <button
      display-if={canAddAnotherBarber}
      type="button"
      className="c-btn c-btn--medium"
      onClick={on}
    >
      Add another barber
    </button>
    <Modal
      title="Choose a barber"
      close={off}
      showCloseButton
      display-if={isOn}
    >
      <div className="u-mv">
        {barbers.map(barber => (
          <button
            key={barber.id}
            type="button"
            className="c-btn c-btn--outline c-btn--small u-1/2 u-margin-auto u-mv- u-block"
            onClick={addBarber(barber.id)}
          >
            {barber.firstName} {barber.lastName}
          </button>
        ))}
      </div>
    </Modal>
  </div>
);
AddAnotherBarber.propTypes = {
  barbers: shapes.barbers.isRequired,
  addBarber: shapes.handler.isRequired,
  on: shapes.handler.isRequired,
  off: shapes.handler.isRequired,
  isOn: shapes.flag.isRequired,
  canAddAnotherBarber: shapes.flag.isRequired,
};

export default AddAnotherBarber;
